import React, { cloneElement, useEffect } from 'react';
import { IControlledStore, useStores } from '@monorepo/controlled/src/hooks/use-stores';
import styles from './modal.module.scss';

export interface IModalInjectProps {
	id: number;
	closeModal?: () => void;
}

export interface IModal {
	children: JSX.Element;
	id: number;
}

// TODO - RONT css warning error and info fix
export const Modal = (props: IModal) => {
	const { children, id = 0 } = props;
	const { modalsStore } = useStores<IControlledStore>();

	const closeModal = () => {
		modalsStore.removeModal(id);
	};

	const handleKeyDownEvent = (e: KeyboardEvent) => {
		if (e.key === 'Escape') {
			modalsStore.removeModal(id);
		}
	};

	useEffect(() => {
		window.addEventListener('keydown', handleKeyDownEvent);

		return () => {
			window.removeEventListener('keydown', handleKeyDownEvent);
		};
	}, []);

	const smartChildren = React.Children.map(children, child => {
		return cloneElement(child, {
			closeModal,
			id,
		});
	});

	return (
		<div className={styles.overlay} onClick={closeModal}>
			<div className={styles.modalWrapper} onClick={e => e.stopPropagation()}>
				{smartChildren}
			</div>
		</div>
	);
};
